import color from "../../constants/color";

const styles= {
  imageContainer:{
    position:"relative",
  },
  loaderOverlay: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.75)",
  },
  choose: {
    fontSize: "14px",
    color: color.card,
  },
  chooseIconSection: {
    backgroundColor: color.primary,
    display: "flex",
    p :1,
    mx:1,
    borderRadius: "9px", 
    width: "fit-content",

 
  },
  dragText: {
    fontSize:"12px"
  },
  cameraIcon:
    {position:"absolute",
      bottom:0,
      right:1,
      padding:0.5,
      borderRadius:"100%",
      backgroundColor:color.card,}
  ,
  editActionButton: {
    position: "absolute",
    bottom: 0,
    right: 1,
    padding: 0.5,
    borderRadius: "100%",
    backgroundColor: color.card,
    color: color.red,
    minWidth: "auto",
    "&:hover": {
      backgroundColor: color.card,
    },
  },
  deleteIcon: {
    position: "absolute",
    top: -6,
    right: -6,
    backgroundColor: color.card,
    color: color.red,
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.18)",
    "&:hover": {
      backgroundColor: color.card,
    },
  }
  
};
export default styles;
